import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCompare = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m13 15-5 5-1.4-1.425L9.175 16H2v-2h7.175L6.6 11.425 8 10zm4.4-9.575L14.825 8H22v2h-7.175l2.575 2.575L16 14l-5-5 5-5z" })
});
export default SvgCompare;
